import type { RouteRecordRaw } from 'vue-router'
import { HelmPermission } from '@helm/services/api/client'
import { HELM_QUERY_KEYS } from '@helm/constants/query'
import useHelmApi from '@helm/composables/helmApi'
import queryClient from '@helm/plugins/query'
import { firstSideNavRoute } from '@helm/utils/sideNav'

const config: readonly RouteRecordRaw[] = [
    {
        // Opens the first Config page the person can see - App Config is only for some, so it can't be fixed.
        path: `/config`,
        name: `config`,
        component: () => import('@helm/pages/Home.vue'),
        beforeEnter: async () => {
            const { api } = useHelmApi()
            const me = await queryClient.ensureQueryData({
                queryKey: HELM_QUERY_KEYS.me,
                queryFn: () => api.authentication.getLoggedInUser().then(({ data }) => data)
            })
            return firstSideNavRoute(`config`, me?.permissions ?? []) ?? { name: `home` }
        }
    },
    {
        path: `/config/app`,
        component: () => import('@helm/pages/Config/AppConfigList.vue'),
        name: `appConfig.index`,
        meta: {
            props: {
                sideNav: `config`
            }
        }
    },
    {
        path: `/config/service-plan-templates`,
        component: () => import('@helm/pages/Config/index.vue'),
        name: `service-plan-templates`,
        meta: {
            props: {
                sideNav: `config`
            }
        }
    },
    {
        path: `/config/integrations`,
        component: () => import('@helm/pages/Config/Integrations.vue'),
        name: `config.integrations`,
        meta: {
            props: {
                sideNav: `config`
            }
        }
    },
    {
        path: `/config/ip-allowlist`,
        component: () => import('@helm/pages/Config/IpAllowlist.vue'),
        name: `config.ip-allowlist`,
        meta: {
            props: {
                sideNav: `config`
            },
            roles: [HelmPermission.HELM_IP_ALLOWLIST_READ, HelmPermission.HELM_IP_ALLOWLIST_WRITE]
        }
    },
    {
        path: `/config/retryable-jobs`,
        component: () => import('@helm/pages/Config/RetryableJobs.vue'),
        name: `config.retryable-jobs`,
        meta: {
            props: {
                sideNav: `config`
            }
        }
    },
    {
        path: `/config/feature-flags`,
        component: () => import('@helm/pages/Config/FeatureFlags.vue'),
        name: `config.feature-flags`,
        meta: {
            props: {
                sideNav: `config`
            },
            roles: [
                HelmPermission.HELM_FEATURE_READ,
                HelmPermission.HELM_FEATURE_WRITE,
                HelmPermission.HELM_FEATURE_DELETE
            ]
        }
    },
    {
        path: `/config/feature-flags/:id(\\d+|new)`,
        component: () => import('@helm/pages/Config/FeatureFlag.vue'),
        name: `config.feature-flags.edit`,
        meta: {
            props: {
                sideNav: `config`
            },
            roles: [
                HelmPermission.HELM_FEATURE_READ,
                HelmPermission.HELM_FEATURE_WRITE,
                HelmPermission.HELM_FEATURE_DELETE
            ]
        }
    },
    {
        path: `/config/nav-table`,
        component: () => import('@helm/pages/Config/NavigationTable.vue'),
        name: `config.nav-table`,
        meta: {
            props: {
                sideNav: `config`
            },
            roles: [HelmPermission.HELM_NAVIGATION]
        }
    }
]

export default config
